module.exports = __webpack_public_path__ + "img/chrome-logo.25da87f5.jpg";